module.exports = __webpack_public_path__ + "img/charactor_01.f413cccc.png";